import React from 'react';
import { Paper, Typography, Grid, Box } from '@mui/material';
import moment from 'moment';
import { UserMentionInput } from './UserMentionInput';

interface CommentListItemProps {
  comment: any;
}

export const CommentListItem = ({ comment }: CommentListItemProps) => {
  const name = `${comment?.author?.firstname} ${comment?.author?.lastname}`;
  return (
    <Paper
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        pt: 3,
        pb: 2,
        backgroundColor: theme => (name ? '#ffffff1f' : 'white'),
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography variant="body2" color="textSecondary">
            {name ? name : 'Centerpiece'}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2" color="textSecondary">
            {moment(comment.created_at).format('hh:mm A MMM D ‘YY')}
          </Typography>
        </Grid>
      </Grid>

      <Box sx={{ mt: 4 }}>
        {comment.comment && comment.comment !== '' && (
          <UserMentionInput value={comment.comment} disabled={true} />
        )}
      </Box>
    </Paper>
  );
};
